import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  class: "driverChart mt-4",
  style: {"width":"90%"}
}
const _hoisted_4 = { style: {"padding":"0px","font-size":"14px","color":"rgba(0,0,0,0.6)"} }
const _hoisted_5 = { style: {"width":"75%","height":"48px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_ctx.locationDrivers)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.location)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_2, _toDisplayString(_ctx.location.name), 1))
          : _createCommentVNode("", true),
        _createElementVNode("table", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredLocationDrivers, (d, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              _createElementVNode("td", _hoisted_4, _toDisplayString(d.title), 1),
              _createElementVNode("td", _hoisted_5, [
                _createElementVNode("div", {
                  style: _normalizeStyle({ 'margin-left': 'auto', 'margin-right': 'auto',  width: d.width + '%', height: '32px', position: 'relative', display: 'block' })
                }, [
                  (d.inverse == false)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        style: _normalizeStyle({ position: 'absolute', top: 0, left: '0%', height: '100%', width: '100%',  'background-image': 'linear-gradient(to right, rgb(255, 69, 96) ' + (d.minPos + 20) + '%, rgb(0, 227, 150) ' + (d.maxPos - 20) + '%)'})
                      }, null, 4))
                    : _createCommentVNode("", true),
                  (d.inverse == true)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        style: _normalizeStyle({ position: 'absolute', top: 0, left: '0%', height: '100%', width: '100%', 'background-image': 'linear-gradient(to right, rgb(0, 227, 150) ' + (d.minPos + 20) + '%, rgb(255, 69, 96) ' + (d.maxPos - 20) + '%)'})
                      }, null, 4))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_tooltip, { location: "bottom" }, {
                    activator: _withCtx(({ props }) => [
                      _createElementVNode("div", _mergeProps({ ref_for: true }, props, {
                        style: { 'padding-left': '5px', 'font-size': '10px', position: 'absolute', top: '-10px', left: d.avgPos + '%', height: '64px', width: '0px', 'border-left': '3px dashed #FEB019'}
                      }), null, 16)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(d.average), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("div", {
                    style: _normalizeStyle({ position: 'absolute', top: 0, left: '0%', height: '100%', width: d.minPos + '%', 'background-color': 'white' })
                  }, null, 4),
                  _createElementVNode("div", {
                    style: _normalizeStyle({ position: 'absolute', top: 0, left: d.minPos + d.maxPos  + '%', height: '100%', width: 100 - d.minPos - d.maxPos + '%', 'background-color': 'white' })
                  }, null, 4),
                  _createElementVNode("div", {
                    style: _normalizeStyle({ 'background-color': 'white', 'padding': '3px', 'font-size': '12px', position: 'absolute', height: '40px',  top: '-4px', right: '-1%', width:  100- d.maxPos + 1  + '%'})
                  }, null, 4),
                  _createElementVNode("div", {
                    style: _normalizeStyle({ 'background-color': 'white', 'padding': '3px', 'font-size': '12px', position: 'absolute', height: '40px', top: '-4px', left: '-1%', width: d.minPos + 1 + '%'})
                  }, null, 4),
                  _createElementVNode("div", {
                    style: _normalizeStyle({ 'background-color': 'white', 'padding': '9px', 'font-size': '12px', position: 'absolute', height: '40px',  top: '-4px', right: 100- d.minPos  + '%'})
                  }, _toDisplayString(_ctx.$filters.rounding(d.minimum, _ctx.$i18n.locale, d.roundingDigits)), 5),
                  _createElementVNode("div", {
                    style: _normalizeStyle({ 'background-color': 'white', 'padding': '9px', 'font-size': '12px', position: 'absolute', height: '40px', top: '-4px', left: d.maxPos + '%'})
                  }, _toDisplayString(_ctx.$filters.rounding(d.maximum, _ctx.$i18n.locale, d.roundingDigits)), 5),
                  (d.value > d.average)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        style: _normalizeStyle({'font-size':'12px', 'padding': '5px','padding-right': '1px',color: '#FFFFFF',  'font-weight': 'normal', position: 'absolute', top: 0, right: 100 - d.valPos + '%', height: '100%', 'border-right': '3px solid #775DD0'})
                      }, _toDisplayString(_ctx.$filters.rounding(d.value, _ctx.$i18n.locale, d.roundingDigits)), 5))
                    : _createCommentVNode("", true),
                  (d.value < d.average)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 3,
                        style: _normalizeStyle({'font-size':'12px','padding': '5px', 'padding-left': '1px', color: '#FFFFFF', 'font-weight': 'normal', position: 'absolute', top: 0, left: d.valPos + '%', height: '100%', 'border-left': '3px solid #775DD0'})
                      }, _toDisplayString(_ctx.$filters.rounding(d.value, _ctx.$i18n.locale, d.roundingDigits)), 5))
                    : _createCommentVNode("", true)
                ], 4)
              ])
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}